import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function Button({
  href,
  children,
  className = ''
}: ButtonProps) {
  return <motion.a href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`flex flex-col items-center justify-center w-full bg-[#D97757] hover:bg-[#c26547] text-white font-bold text-lg py-5 px-6 rounded-xl shadow-lg transition-colors text-center gap-2 ${className}`} data-id="element-27">
      <span data-id="element-28">{children}</span>
    </motion.a>;
}